import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProcessorsManagement from '../ProcessorsManagement';
import { useProcessorStates } from '../ProcessorStateBadge';
import { Card } from '../ui';
import { processorRegistry } from './processorRegistry';
import { selectedFromSearchParams, applySelection } from './consoleView';
import { ProcessorList } from './ProcessorList';
import { FleetStrip } from './FleetStrip';
import { GenericProcessorPanel } from './GenericProcessorPanel';
import './processors.css';

const ProcessorsConsole: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState('');
  const states = useProcessorStates();

  if (searchParams.get('classic') === '1') return <ProcessorsManagement />;

  const visibleEntries = processorRegistry.filter((e) => !e.retired);
  const selectedId = selectedFromSearchParams(searchParams, visibleEntries);
  const entry = visibleEntries.find((e) => e.id === selectedId);
  const Panel = entry?.component;

  return (
    <div className="pc-console">
      <FleetStrip states={states} ids={visibleEntries.map((e) => e.id)} />
      <div className="pc-console__body">
        <ProcessorList
          entries={visibleEntries} states={states}
          selectedId={selectedId}
          onSelect={(id) => setSearchParams((prev) => applySelection(prev, id))}
          query={query} onQueryChange={setQuery}
        />
        <div className="pc-console__panel">
          {entry ? (Panel ? <Panel /> : <GenericProcessorPanel entry={entry} state={states[entry.id]} />)
                 : <Card title="No processor selected">Select a processor from the list.</Card>}
        </div>
      </div>
    </div>
  );
};

export default ProcessorsConsole;
